import { Button, Kind } from '@thanx/uikit/button'
import { createCampaignVariant } from 'actions/campaignVariants'
import { alert } from 'actions/flash'
import { useCreateUserListCampaignMutation, UserList } from 'api/userLists'
import PopoverMenu, { PopoverOption } from 'components/PopoverMenu'
import Spinner from 'components/Spinner'
import {
  ListCard,
  ListCardActions,
  ListCardMeta,
  ListCardTitle,
} from 'controlled-components/ListCard'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import { history } from 'store'
import DeleteListModal from './DeleteListModal.container'
import RenameListModal from './RenameListModal.container'

const t = buildTranslate('user_lists.landing')

type Props = {
  list: UserList
}

const ListCardRow: React.FC<Props> = ({ list }) => {
  const dispatch = useDispatch()
  const [isDeleteOpen, setIsDeleteOpen] = useState(false)
  const [isRenameOpen, setIsRenameOpen] = useState(false)
  const [createCampaign, { isLoading: isCreatingCampaign }] =
    useCreateUserListCampaignMutation()

  const handleImportCustomers = () => {
    history.push(`/user_lists/${list.id}?import=true`)
  }

  const handleCreateCampaign = async () => {
    try {
      const result = await createCampaign({
        userListId: list.id,
        listName: list.name,
      }).unwrap()
      const campaignId = result.campaign.id
      await dispatch(createCampaignVariant(campaignId))
      dispatch(push(`/thanx_campaigns/targeted/custom/${campaignId}`))
    } catch {
      dispatch(
        alert({
          key: 'danger',
          message: t('create_campaign_error'),
        })
      )
    }
  }

  return (
    <ListCard>
      <div className="d-flex flex-column flex-grow-1">
        <Link to={`/user_lists/${list.id}`} className="no-underline">
          <ListCardTitle name={list.name} />
        </Link>
        <ListCardMeta createdAt={list.createdAt} />
      </div>
      <ListCardActions>
        <PopoverMenu dismissOnClickOutside closeOnClick>
          <PopoverOption onClick={handleCreateCampaign}>
            <Spinner isLoading={isCreatingCampaign} size="1x">
              {t('create_campaign')}
            </Spinner>
          </PopoverOption>
          <PopoverOption onClick={handleImportCustomers}>
            {t('import_customers')}
          </PopoverOption>
          <PopoverOption onClick={() => setIsRenameOpen(true)}>
            {t('rename')}
          </PopoverOption>
          <PopoverOption onClick={() => setIsDeleteOpen(true)}>
            {t('delete_list')}
          </PopoverOption>
        </PopoverMenu>
        <Link to={`/user_lists/${list.id}`} className="ml-s no-underline">
          <Button kind={Kind.SECONDARY} size="small">
            {t('view')}
          </Button>
        </Link>
      </ListCardActions>
      <DeleteListModal
        isOpen={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        listId={String(list.id)}
        listName={list.name}
      />
      <RenameListModal
        isOpen={isRenameOpen}
        onClose={() => setIsRenameOpen(false)}
        listId={String(list.id)}
        listName={list.name}
      />
    </ListCard>
  )
}

export default ListCardRow
